<template>
  <div class="shop-apply-wrap">
    <!--选择申请企业类型-->
    <div v-if="applyForm.store_type==''">
      <div class="apply-type-box">
        <h2>选择申请企业类型</h2>
        <p>请选择您要注册的身份类型，我们将根据您的选择为您提供相应的注册</p>
      </div>
      <div>
        <ul class="apply-type-list">
          <li @click="applyForm.store_type='3';">
            <img src="/images/public/Identity-1.png" alt="">
            <h2>供应商</h2>
            <p>如果您是酒店、民宿、度假村、公寓等住宿供应商，请选择此身份。</p>
          </li>
          <li @click="applyForm.store_type='2';">
            <img src="/images/public/Identity-2.png" alt="">
            <h2>采购商</h2>
            <p>如果您是企业采购商、会务公司、旅行社等采购方，请选择此身份。</p>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="applyForm.store_type&&isSuccess">
      <div class="title-box">
        <p>请填写以下信息，提交后我们将尽快处理您的申请</p>
      </div>
      <el-form
        ref="applyFormRef"
        :model="applyForm"
        :rules="applyRules"
        label-width="120px"
        class="apply-form"
        size="small"
      >
        <el-form-item label="企业类型" prop="store_type">
          <el-select v-model="applyForm.store_type" placeholder="请选择企业类型" :disabled="shopType">
            <el-option label="供应商" value="3"></el-option>
            <el-option label="采购商" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人姓名" prop="truename">
          <el-input v-model="applyForm.truename" placeholder="请输入申请人姓名" :disabled="shopType"></el-input>
        </el-form-item>

        <el-form-item label="申请人手机号" prop="mobile">
          <el-input v-model="applyForm.mobile" placeholder="请输入申请人手机号" :disabled="shopType"></el-input>
        </el-form-item>

        <el-form-item label="验证码" prop="sms_code" v-if="!shopType">
          <div class="code-row">
            <el-input v-model="applyForm.sms_code" placeholder="请输入验证码"></el-input>
            <el-button :disabled="codeDisabled" @click="getCode">{{ btnText }}</el-button>
          </div>
        </el-form-item>

        <el-form-item label="申请企业名称" prop="title">
          <el-input v-model="applyForm.title" placeholder="请输入申请企业名称"></el-input>
        </el-form-item>
        <!--提示-->
        <div class="tip-box" v-if="type==3"><i class="el-icon-warning" ></i>申请企业名称建议与携程平台同步</div>
        <el-form-item label="申请企业电话" prop="tel">
          <el-input v-model="applyForm.tel" placeholder="请输入申请企业电话"></el-input>
        </el-form-item>
        <el-form-item label="省市区" prop="district"  >
        <select-city class=""
            :release="true"
            :width="60"
            :order="true"
            @getCityInfo="getCityInfo"
            />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="applyForm.address" placeholder="请输入详细地址" @blur="checkAddress"></el-input>
        </el-form-item>
          <div class="existence red" v-if="checkAddressCount>0">当前地址存在<span> {{checkAddressCount}} </span>个门店  
            <el-popover
              placement="right"
              width="370"
              trigger="click">
              <el-table :data="checkAddressList" >
                <el-table-column width="200" property="title" label="酒店名称"></el-table-column>
                <el-table-column width="150" property="time" label="注册时间" align="center">
                  <template slot-scope="scope">
                    {{scope.row.time | formatTimestamp(1)}}
                  </template>
                </el-table-column>
              </el-table>
              <el-button class="ml-2" size="mini" slot="reference">查看</el-button>
            </el-popover>
          </div>
        <el-form-item>
          <el-button type="primary" class="submit-btn mb-4" @click="handleSubmit">提交申请</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-if="!isSuccess">
      <div class="title-box">
        <img src="/images/public/success/isSuccess_1.jpg" alt="">
        <h2>企业申请成功</h2>
        <p>您的企业申请已提交成功，我们将尽快进行审核，</p>
        <p>审核结果将通过短信或站内信通知您，请耐心等待</p>
        <el-button type="primary" class="submit-btn" @click="$router.push('/index_page')">返回首页</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions,mapGetters,mapState } from 'vuex'
  import _ from 'lodash'
  let shopTimer = null
  export default {
  name: "StoreApplication",
  data() {
    const checkShopName = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入申请企业名称'))
      if (value.length < 3) return callback(new Error('企业名称长度必须在3个字符以上'))
      clearTimeout(shopTimer)
      shopTimer = setTimeout(async () => {
        try {
          let data={
            title:value,
            type:this.applyForm.store_type, 
            page:1,
            num:10,
          }
          let result = await this.POST_checkStoreTitle(data);
          let existence=result.list.some((item) => {
            return item.title === value;
          })
          // const res = await this.$axios.post('/pc/Shop/checkRepeat', { title: value })
          if (existence) {
            res.data.isRepeat ? callback(new Error('该企业名称已存在，请更换名称')) : callback()
          } else {
            callback()
          }
        } catch (e) {
            callback(new Error('该企业名称已存在，请更换名称'))
        }
      }, 500)
    }
    return {
      //不可修改
      shopType: false,
      codeDisabled: false,
      timer: null,
      isSuccess: true,
      btnText: "获取验证码",
      applyForm: {
        truename: "",        //申请人姓名
        mobile: "",          //申请人手机号
        sms_code: "",        //验证码
        title: "",           //申请企业名称
        tel: "",             //申请企业电话
        province: "",        //省
        city: "",            //市
        district: "",        //区县编码
        address: "",         //详细地址
        store_type: ""             //企业类型
      },
      mobileverify:[],     //已发送验证码手机号
      checkAddressCount:0, //检查地址是否存在多个门店的个数
      storeList:[],        //门店列表
      applyRules: {
        truename: [{ required: true, message: "请输入申请人姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur" }
        ],
        sms_code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        title: [
          { required: true, message: "请输入申请企业名称", trigger: "blur" },
          { validator: checkShopName, trigger: 'blur' }
        ],
        tel: [{ required: true, message: "请输入企业电话", trigger: "blur" }],
        province: [{ required: true, message: "请选择省份", trigger: "change" }],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        district: [{ required: true, message: "请选择区县", trigger: "change" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        shopType: [{ required: true, message: "请选择企业类型", trigger: "change" }]
      }
    };
  },
  watch:{
    'applyForm.mobile':{
      handler(newVal){
        this.isSendCode(newVal);
      },
    },
  },
  computed: {
    ...mapState(['userLoginMessage']),
     ...mapGetters(['userInfo','isGroup']),
    type(){
      return this.$route.query.type;
    }
  },
  mounted(){
    if(this.userLoginMessage){
      this.applyForm.store_type=this.type;
      this.applyForm.truename=this.userLoginMessage.truename;
      this.applyForm.mobile=this.userLoginMessage.mobile;
      this.shopType=true;
    }
  },
  methods: {
    ...mapActions(['POST_checkStoreTitle','POST_RegApplyStore','POST_Admin_SearchHotelAddress']),
    getCode:_.debounce(async function(newVal) {
      if (this.codeDisabled) return;
      if (!this.applyForm.mobile) {
        this.$message.warning("请先填写手机号");
        return;
      }
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(this.applyForm.mobile)) {
        this.$message.warning("手机号格式不正确");
        return
      }
      let resData = await this.$axios.post('/pc/Reglogin/GetLoginCode', {mobile:this.applyForm.mobile})
      if (resData.code === '00000') {
          this.countdown(60);
          this.$message({message: '验证码发送成功',duration:1000})
          //保存已发送验证码手机号刷新再次发送情况
          const index = this.mobileverify.findIndex(user => user.mobile === this.applyForm.mobile);
          if (index !== -1) {
              this.mobileverify[index]={mobile:this.applyForm.mobile,tiem:new Date().getTime()};
          }else{
              this.mobileverify.push({mobile:this.applyForm.mobile,tiem:new Date().getTime()});
          }
          sessionStorage.setItem('mobileverify',JSON.stringify(this.mobileverify));
      }
    },1000),
    //判断是否已经发送了验证码
    isSendCode(phoneNumber) {
        console.log(phoneNumber)
        let mobileverify =JSON.parse(sessionStorage.getItem('mobileverify'))||[];
        let tiem=mobileverify.filter(todo=>todo.mobile==phoneNumber)[0];
        let nowTime=new Date().getTime();
        if(tiem&&(nowTime-tiem.tiem)<60000){
          let num =60-(nowTime-tiem.tiem)/1000;
            this.countdown(num.toFixed(0));
        }
        this.mobileverify=mobileverify;
    },
    //倒计时
    countdown(count){
      this.codeDisabled = true;
      this.btnText = `${count}s后重新获取`;
      this.timer = setInterval(() => {
        count--;
        this.btnText = `${count}s后重新获取`;
        if (count <= 0) {
          clearInterval(this.timer);
          this.codeDisabled = false;
          this.btnText = "获取验证码";
        }
      }, 1000);
    },
    provinceChange() {
      this.applyForm.city = "";
      this.applyForm.district_code = "";
    },
    cityChange() {
      this.applyForm.district_code = "";
    },
    handleSubmit() {
      this.$refs.applyFormRef.validate(async valid => {
        if (!valid) return;
        // 提交参数直接对应后端字段
        const params = {
          ...this.applyForm
        };
        // 提交企业申请注册
        this.POST_RegApplyStore({
          data:params,
          successFun:(res)=>{
            this.isSuccess=false;
          }
        })
        /*
        // 提交参数直接对应后端字段
        const res = await this.$axios.post('/api/xxx', params)
        if(res.code === 0){
          this.$message.success('提交成功')
          this.$refs.applyFormRef.resetFields()
        }
        */
      });
    },
    //获取省市区id
    getCityInfo (info) {
      this.applyForm.province = info.province;
      this.applyForm.city = info.city;
      this.applyForm.district = info.district;
      if(info.district){
        this.checkAddress();
      }
    },
    //检查地址是否存在多个门店
    checkAddress(){
        if(this.applyForm.district&&this.applyForm.address!=''&&this.type==3){
          const { province, city, district, address } = this.applyForm
          this.POST_Admin_SearchHotelAddress({
            data:{
              province,
              city, 
              district,
              address,
            },
            successFun:(res)=>{ 
              console.log(res);
              this.checkAddressCount=res.count;
              res.list.forEach(item=>{
                item.create_name=item.create_name||'无';
              })
              this.checkAddressList=res.list;
            }
          })
        }
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style scoped>
  .existence{
   
      padding-bottom: 1rem;
      text-align: left;
      font-size: 12px;
      text-indent: 10em;  
  }
.shop-apply-wrap{
    width: 80%;
    margin: 20px auto;
}
.apply-card {
  max-width: 1000px;
  margin: 0 auto;
}

.title-box img{
  width: 20%;
}
.title-box p {
  color: #888;
  margin: 6px 0 24px;
  margin-top:20px;
}
.code-row {
  display: flex;
  gap:12px;
}
.code-row >>> .el-input {
  flex: 1;
}
.area-row {
  display: flex;
  gap:12px;
}
.area-row >>> .el-select {
  flex: 1;
}
.submit-btn {
  width: 320px;
  height: 44px;
  font-size:16px;
}
.apply-form >>> .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right:4px;
}
.apply-type-box{
  text-align: left;
}
.apply-type-list{
  display: flex;
  justify-content: space-between;
  margin-top: 46px;
}
.apply-type-list li{
  width: 46%;
  border-radius: 4px;
  border: 1px solid #83b7fa;
  background-color: #f4f8fd;
  cursor: pointer;
}
.apply-type-list li:nth-child(2){
   border: 1px solid #ceebe3;
    background-color: #f8fdf9;
}
.apply-type-list li img{
  width: 30%;
}
.apply-type-list li p{
  width: 74%;
  margin: 16px auto;
  color: #999;
}
.tip-box{
  font-size: 12px;
  color: var(--smtc-color-primary);
  margin-top: 12px;
  background-color: #ecf5ff;
  width: 83.5%;
  margin-left: 12.5%;
  padding: 6px 2%;
  text-align: left;
  border-radius: 4px;
  margin-bottom: 12px;
}
.tip-box i{
  margin-right: 6px;
}
</style>

<style>
    .shop-apply-wrap .el-select{
        width: 100%;
    }
</style>
